<template>
  <div class="content-box">
    <ul class="app-view" v-if="versionUrl">
      <li>
        <img :src="appIcon" alt />
        <p>{{ appName }}</p>
      </li>
      <li>
        <a href="javascript:;" @click="openApp">打开app</a>
      </li>
    </ul>
    <video
      :src="
        params.liveState == 1
          ? source
          : params.activityGifLow || params.activityGif
      "
      v-if="params.liveState == 1 || params.activityGifType == 0"
      class="video"
      x5-video-player-type="h5"
      webkit-playsinline="true"
      playsinline="true"
      autoplay
      controls
    ></video>
    <img
      :src="params.activityGifLow || params.activityGif"
      v-else
      alt=""
      class="pic"
    />
    <div class="picture">
      <ul>
        <li
          v-for="(val, ind) in params.multiCamera == 1
            ? []
            : params.activityFrameList"
          :key="ind"
          @click="frameChange(val, ind)"
        >
          <img :src="val.frameImageLow || val.frameImage" alt="" />
          <p>{{ val.frameTitle }}</p>
        </li>
      </ul>
    </div>
    <a href="javascript:;" @click="openApp" class="open-app" v-if="versionUrl"
      >打开{{ appName }}，观看精彩直播</a
    >
    <p class="title">{{ params.activityTitle }}</p>
    <ul class="publisher">
      <li>{{ params.activityAuthor }}</li>
      <!-- <li>观看数</li> -->
    </ul>
    <ul class="Introduction">
      <li>简介:</li>
      <li>{{ params.activityIntroduce }}</li>
    </ul>
  </div>
</template>

<script>
//地址  访问地址+/liveShare?id=797368996706215838&bundleID=
import * as sctipts from "../service/share";
export default {
  data() {
    return {
      type: "0",
      versionUrl: "",
      appName: "",
      appIcon: "",
      params: {},
      source: "",
    };
  },
  mounted() {
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .getActLive2(this.$route.query.id)
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data) {
              this.params = data.data;
              document.title = this.params.activityTitle;
              if (
                this.params.multiCamera == 0 &&
                this.params.activityLiveType == 1
              ) {
                // 推流多机位
                this.source = this.params.activityFrameList[0].hlsPlayPath;
              } else if (
                this.params.multiCamera == 1 &&
                this.params.activityLiveType == 1
              ) {
                // 推流单机位
                this.source = this.params.hlsPlayPath;
              } else if (
                this.params.multiCamera == 0 &&
                this.params.activityLiveType == 0
              ) {
                // 拉流多机位
                this.source = this.params.activityFrameList[0].framePullPath;
              } else if (
                this.params.multiCamera == 1 &&
                this.params.activityLiveType == 0
              ) {
                // 拉流单机位
                this.source = this.params.activityPullPath;
              }
            }
          } else {
            alert(data.desc);
            console.log(data.desc);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      sctipts
        .getAppUrl({ type: this.type, bundleID: this.$route.query.bundleID })
        .then(({ data }) => {
          if (data.status == 0) {
            // this.webcommentList = data.data;
            if (data.data) {
              this.versionUrl = data.data.versionUrl;
              this.appName = data.data.applicationName;
              this.appIcon = data.data.applicationHeadPath;
              this.appScheme = data.data.applicationUrlScheme
            }
          } else {
            console.log(data.desc);
          }
        });
    } else {
      console.log("未获取id");
    }
  },
  computed: {},
  methods: {
    equipmentType() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime(time) {
      return sctipts.initTime(time);
    },
    // downApp() {
    //   let u = navigator.userAgent;
    //   let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   if (isAndroid) {
    //     let ua = navigator.userAgent.toLowerCase();
    //     let isWeixin = ua.indexOf("micromessenger") != -1;
    //     if (isWeixin) {
    //       alert("请点击右上方选择浏览器打开本页面下载app");
    //     } else {
    //       window.location.href = this.versionUrl;
    //     }
    //   } else if (isiOS) {
    //     window.location.href = this.versionUrl;
    //   } else {
    //     alert("请使用手机打开本页面。");
    //   }
    // },
    openApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(9)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(9)}?sourceId=${this.$route.query.id}`;
        }
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        
        window.location = link; //schema链接或者universal link
        // var loadDateTime = new Date();
        // window.setTimeout(() => {
        //   //如果没有安装app,便会执行setTimeout跳转下载页
        //   var timeOutDateTime = new Date();
        //   if (timeOutDateTime - loadDateTime < 5000) {
        //     window.location = this.versionUrl; //ios下载地址
        //   } else {
        //     window.close();
        //   }
        // }, 500);
      } else if (navigator.userAgent.match(/android/i)) {
        try {
          window.location = link; //schema链接或者universal link
          // window.setTimeout(() => {
          //   let ua = navigator.userAgent.toLowerCase();
          //   let isWeixin = ua.indexOf("micromessenger") != -1;
          //   if (isWeixin) {
          //     alert("请点击右上方选择浏览器打开本页面下载app");
          //   } else {
          //       window.location.href = this.versionUrl;
          //   }
          // }, 500);
        } catch (e) { }
      }
    },
    // 机位切换
    frameChange(val, ind) {
      if (this.params.multiCamera == 0 && this.params.activityLiveType == 1) {
        //推流多机位
        this.source = val.hlsPlayPath;
      } else if (
        this.params.multiCamera == 0 &&
        this.params.activityLiveType == 0
      ) {
        //拉流多机位
        this.source = val.framePullPath;
      }
    },
  },
};
</script>

<style scoped>
.content-box {
  height: 100%;
}
.app-view {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  align-items: center;
}
.app-view > li:nth-child(1) {
  height: 30px;
}
.app-view > li:nth-child(1) > img {
  width: 30px;
  height: 30px;
  display: block;
  float: left;
}
.app-view > li:nth-child(1) > p {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  float: left;
  margin-left: 8px;
  line-height: 30px;
}
.app-view > li:nth-child(2) {
  height: 28px;
}
.app-view > li:nth-child(2) > a {
  display: block;
  width: 73px;
  height: 28px;
  background-color: #5b82e4;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  text-align: center;
  line-height: 28px;
  text-decoration: none;
  border-radius: 5px;
}
.video {
  display: block;
  width: 100%;
  height: 210px;
  background-color: black;
}
.pic {
  display: block;
  width: 100%;
  height: 210px;
  background-color: black;
  object-fit: contain;
}
.title {
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
  padding: 0 15px;
}
.publisher {
  width: calc(100% - 30px);
  margin: 0 auto;
  font-size: 12px;
  color: #8a8a8a;
  display: flex;
  align-items: center;
}
.publisher > li {
  margin-right: 15px;
}
.Introduction {
  width: calc(100% - 30px);
  margin: 22px auto;
  font-size: 14px;
  color: #333333;
  display: flex;
}
.Introduction > li:nth-child(1) {
  margin-right: 10px;
  flex-shrink: 0;
}
.open-app {
  width: calc(100% - 30px);
  display: block;
  border: none;
  height: 44px;
  color: #5b82e4;
  border: 1px solid#5B82E4;
  font-size: 15px;
  border-radius: 5px;
  margin: 23px auto 18px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
  font-weight: bold;
}
.picture {
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  margin-top: 17px;
}
.picture > ul {
  display: flex;
  align-items: center;
  width: auto;
}
.picture > ul > li {
  width: 118px;
  height: 95px;
  padding: 0 4px;
  flex-shrink: 0;
}
.picture > ul > li > img {
  display: block;
  width: 118px;
  height: 75px;
  border-radius: 4px;
  object-fit: contain;
  border: 1px solid #eee;
}
.picture > ul > li > p {
  height: 20px;
  line-height: 20px;
  color: #333333;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
